import React, { Component } from "react";
import Draggable from "react-draggable";
import ReactTooltip from "react-tooltip";
import { withRouter } from "react-router-dom";
import { MASTER_FILTER_KEYS } from "../../smartCharts/constants";
import buildingActions from "../../building/actions";
import recommendationActions from "../../recommendations/actions";
import { DYNAMIC_FIELD_TYPES } from "../constants";
import { connect } from "react-redux";

class ConfirmationModal extends Component {
    state = {
        isDoubleCheckOk: false,
        isDeletePermanent: false,
        isRestoreCheckOk: false,
        isUnassignCheckOk: false,
        filterLists: {},
        globalfilterLists: {},
        isSyncCheckOk: false
    };

    componentDidMount = async () => {
        if (this.props?.chartData && (this.props.clientCoreReport > 0 || this.props.globalCoreReport > 0)) {
            const clientId = this.props?.chartData["project"]?.band1?.mfilter?.client_ids || this.props?.client;
            const project_id = this.props?.chartData["project"]?.band1?.mfilter?.project_ids;
            if (clientId) await this.props.getBuildingDynamicFields({ client_id: clientId });
            project_id && (await this.props.getDynamicFields({ project_id }));

            const filteredDatas = {};
            const filterValue = {};
            const entityFilters = this.props?.dashboardReducer?.filterFields;
            if (entityFilters && this.props.chartData["project"]?.band1?.mfilter) {
                entityFilters.forEach(filter => {
                    const paramKey = filter.paramKey;
                    const currectValue = this.props?.chartData["project"]?.band1?.mfilter;
                    const filterKeyValue =
                        ((currectValue?.filters?.[paramKey]?.key !== "" && currectValue?.filters?.[paramKey]?.key !== null) ||
                            ((currectValue?.filters?.[paramKey]?.filters[0] === "null" ||
                                currectValue?.filters?.[paramKey]?.filters[0] === "not_null" ||
                                currectValue?.filters?.[paramKey]?.filters[0] === "count_gt_1") &&
                                (currectValue?.filters?.[paramKey]?.key === "" || currectValue?.filters?.[paramKey]?.key === null))) &&
                        currectValue?.filters?.[paramKey]?.filters;
                    if (
                        this.props.chartData["project"].band1.mfilter &&
                        (Object.keys(this.props.chartData["project"].band1.mfilter || {}).includes(paramKey) ||
                            filterKeyValue ||
                            currectValue?.top_n?.[paramKey]) &&
                        paramKey !== "client_ids"
                    ) {
                        if (paramKey === "project_ids") {
                            filterValue[paramKey] = {
                                required: true,
                                keep_values: true
                            };
                        } else if (
                            this.props.chartData["project"].band1.mfilter &&
                            (Object.keys(this.props.chartData["project"].band1.mfilter || {}).includes(paramKey) ||
                                filterKeyValue ||
                                currectValue?.top_n?.[paramKey])
                        ) {
                            filterValue[paramKey] = {
                                required: true,
                                keep_values: false
                            };
                        }
                    }
                });
                const CustomFieldChange = (customFields, prefix) => {
                    const { chartData } = this.props;
                    const filters = {};
                    Object.entries(customFields).forEach(([_, item]) => {
                        item.filter(field =>
                            [
                                DYNAMIC_FIELD_TYPES.SELECT,
                                DYNAMIC_FIELD_TYPES.BOOLEAN,
                                DYNAMIC_FIELD_TYPES.NUMBER,
                                DYNAMIC_FIELD_TYPES.CURRENCY,
                                DYNAMIC_FIELD_TYPES?.TEXT
                            ].includes(field.field_type)
                        ).forEach(field => {
                            const paramKey =
                                field.field_type === DYNAMIC_FIELD_TYPES.SELECT || field.field_type === DYNAMIC_FIELD_TYPES.BOOLEAN
                                    ? `${prefix}__${field?.field_name}`
                                    : `${prefix}s.${field?.field_name}`;
                            if (
                                ((chartData["project"].band1.mfilter && Object.keys(chartData["project"].band1.mfilter || {}).includes(paramKey)) ||
                                    (chartData["project"].band1.mfilter?.filters &&
                                        Object.keys(chartData["project"].band1.mfilter?.filters || {}).includes(paramKey))) &&
                                paramKey !== "client_ids"
                            ) {
                                filters[paramKey] = {
                                    required: true,
                                    keep_values: false
                                };
                            }
                        });
                    });
                    return filters;
                };
                const dynamicMasterFilters = this.props?.buildingReducer?.buildingDynamicFields?.building_custom_field
                    ? CustomFieldChange(this.props?.buildingReducer?.buildingDynamicFields?.building_custom_field, "building_dynamic_field")
                    : {};
                const projectFilters = this.props?.recommendationsReducer?.dynamicFields?.recommendation_custom_fields
                    ? CustomFieldChange(
                          this.props?.recommendationsReducer?.dynamicFields?.recommendation_custom_fields,
                          "recommendation_dynamic_field"
                      )
                    : {};

                filteredDatas["project"] = { ...filterValue, ...dynamicMasterFilters, ...projectFilters };
            }

            this.setState(prevState => {
                const newState = {
                    filterLists: prevState.filterLists,
                    globalfilterLists: prevState.globalfilterLists
                };
                if (this.props.clientCoreReport > 0) {
                    newState.filterLists = filteredDatas;
                }
                if (this.props.globalCoreReport > 0) {
                    newState.globalfilterLists = filteredDatas;
                }

                return newState;
            });
        }
        this.nameInput.focus();
        const { isDeleted } = this.props;
        if (isDeleted) {
            await this.setState({ isDeletePermanent: true });
        }
    };

    confirmationDoublecheck = event => {
        this.setState({
            isDoubleCheckOk: false
        });
        if (event.target.value.trim() === "DELETE") {
            this.setState({
                isDoubleCheckOk: true
            });
        }
    };
    confirmRemove = event => {
        this.setState({
            isDoubleCheckOk: false
        });
        if (event.target.value.trim() === "REMOVE") {
            this.setState({
                isDoubleCheckOk: true
            });
        }
    };

    confirmRestore = event => {
        this.setState({
            isRestoreCheckOk: false
        });
        if (event.target.value.trim() === "RESTORE") {
            this.setState({
                isRestoreCheckOk: true
            });
        }
    };

    confirmUnAssign = event => {
        this.setState({
            isUnassignCheckOk: false
        });
        if (event.target.value.trim() === "YES") {
            this.setState({
                isUnassignCheckOk: true
            });
        }
    };
    confirmSync = event => {
        this.setState({
            isSyncCheckOk: false
        });
        if (event.target.value.trim() === "SYNC") {
            this.setState({
                isSyncCheckOk: true
            });
        }
    };

    thousands_separators = num => {
        if (!num) return null;
        let numbe = num?.toString();
        let number = numbe?.split(".");
        number[0] = number[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return number.join(".");
    };
    processCustomFields = (item, prefix, filteredData) => {
        const fields = item.filter(field =>
            [
                DYNAMIC_FIELD_TYPES.SELECT,
                DYNAMIC_FIELD_TYPES.BOOLEAN,
                DYNAMIC_FIELD_TYPES.NUMBER,
                DYNAMIC_FIELD_TYPES.CURRENCY,
                DYNAMIC_FIELD_TYPES?.TEXT
            ].includes(field.field_type)
        );
        fields.forEach(field => {
            const { chartData } = this.props;
            const paramKey =
                field.field_type === DYNAMIC_FIELD_TYPES.SELECT || field.field_type === DYNAMIC_FIELD_TYPES.BOOLEAN
                    ? `${prefix}__${field.field_name}`
                    : `${prefix}s.${field.field_name}`;
            if (
                chartData["project"]?.band1?.mfilter?.[paramKey]?.length > 0 ||
                (chartData["project"].band1.mfilter?.filters && Object.keys(chartData["project"].band1.mfilter?.filters || {}).includes(paramKey))
            ) {
                filteredData[paramKey] = {
                    label: field.label,
                    key: field.field_name,
                    paramKey: paramKey
                };
            }
        });
    };
    getSelectedFilters = () => {
        const filteredDatas = {};
        const entityFilters = this.props?.dashboardReducer?.filterFields
            ?.filter(e => e.label !== "Clients")
            ?.sort((a, b) => {
                if (a.label === "FCA Projects") return -1;
                if (b.label === "FCA Projects") return 1;
                return 0;
            });

        if (entityFilters && this.props?.chartData?.["project"]?.band1?.mfilter) {
            const filteredData = {};
            entityFilters.forEach(filter => {
                const paramKey = filter.paramKey;
                const currectValue = this.props?.chartData["project"]?.band1?.mfilter;
                const filterKeyValue =
                    ((currectValue?.filters?.[paramKey]?.key !== "" && currectValue?.filters?.[paramKey]?.key !== null) ||
                        ((currectValue?.filters?.[paramKey]?.filters[0] === "null" ||
                            currectValue?.filters?.[paramKey]?.filters[0] === "not_null" ||
                            currectValue?.filters?.[paramKey]?.filters[0] === "count_gt_1") &&
                            (currectValue?.filters?.[paramKey]?.key === "" || currectValue?.filters?.[paramKey]?.key === null))) &&
                    currectValue?.filters?.[paramKey]?.filters;
                if (
                    Object.keys(this?.props?.chartData?.["project"].band1.mfilter || {}).includes(paramKey) ||
                    Object.keys(this.props?.chartData["project"].band1.mfilter?.filters || {})?.includes(paramKey) ||
                    currectValue?.top_n?.["recommendations.project_total"]
                ) {
                    if (
                        this.props?.chartData?.["project"]?.band1?.mfilter?.[paramKey]?.length > 0 ||
                        filterKeyValue ||
                        currectValue?.top_n?.[paramKey]
                    ) {
                        filteredData[paramKey] = filter;
                    }
                }
            });
            this.props?.buildingReducer?.buildingDynamicFields?.building_custom_field &&
                Object.entries(this.props?.buildingReducer?.buildingDynamicFields?.building_custom_field).forEach(([_, item]) => {
                    this.processCustomFields(item, "building_dynamic_field", filteredData);
                });
            this.props?.recommendationsReducer?.dynamicFields?.recommendation_custom_fields &&
                Object.entries(this.props?.recommendationsReducer?.dynamicFields?.recommendation_custom_fields).forEach(([_, item]) => {
                    this.processCustomFields(item, "recommendation_dynamic_field", filteredData);
                });
            filteredDatas["project"] = filteredData;
        }
        return filteredDatas;
    };

    handleFilterClick = (entityName, label, keyLabel, checked, type) => {
        const updateState = type === "global" ? "globalfilterLists" : "filterLists";

        this.setState(prevState => ({
            [updateState]: {
                ...prevState[updateState],
                [entityName]: {
                    ...prevState[updateState][entityName],
                    [label]: {
                        ...prevState[updateState][entityName][label],
                        [keyLabel]: checked,
                        ...(type !== "global" && checked && keyLabel === "keep_values" && { required: true })
                    }
                }
            }
        }));
    };

    render() {
        const {
            heading,
            message,
            onNo,
            onYes,
            isUnAssign,
            type = "delete",
            isHard = false,
            onHardDelete,
            isRestore = false,
            isDeleted = false,
            isCutPaste = false,
            isLogChange = false,
            associatedchanges,
            singleOk,
            onlyOk,
            isSurveyImage = false,
            messageClassName = "",
            onCloseModal,
            clearBtnLabel = "",
            ConfirmaBtnLabel = "",
            clearBtnTooltip = "",
            confirmBtnTooltip = "",
            modalClassName = ""
        } = this.props;
        const { isDeletePermanent } = this.state;
        const integerValues = [
            "cost",
            "project_total",
            "area",
            "priority",
            "priority_element1",
            "priority_element2",
            "priority_element3",
            "priority_element4",
            "priority_element5",
            "priority_element6",
            "priority_element7",
            "priority_element8",
            "crv",
            "replacement_cost"
        ];
        return (
            <React.Fragment>
                <div
                    id="modalId"
                    className={`modal modal-region ${this.props?.isCoreReportFilterChangeModal ? "core-report-dtl-modal" : "deleteModal"} ${modalClassName}`}
                    style={{ display: "block" }}
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                >
                    <Draggable cancel=".not-draggable">
                        <div className="modal-dialog draggable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    {singleOk ? (
                                        <button
                                            type="button"
                                            className="close not-draggable"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => onlyOk()}
                                        >
                                            <span aria-hidden="true">
                                                <img src="/img/close.svg" alt="" />
                                            </span>
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="close not-draggable"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => (onCloseModal ?? onNo)()}
                                            disabled={this.props.isLoadingOnYes}
                                        >
                                            <span aria-hidden="true">
                                                <img src="/img/close.svg" alt="" />
                                            </span>
                                        </button>
                                    )}
                                </div>
                                <div className="modal-body region-otr p-3 pb-5">
                                    <div className="deleteInner">
                                        {this.props.isNotOk ? (
                                            <i className="fas fa-times-circle" />
                                        ) : !this.props?.isCoreReportFilterChangeModal ? (
                                            <i className="far fa-check-circle" />
                                        ) : (
                                            ""
                                        )}
                                        <h2 className="not-draggable">{heading}</h2>
                                        {isLogChange ? (
                                            <p className="not-draggable">The Value of Field(s) will be restore to it's previous value</p>
                                        ) : this.state.isDeletePermanent ? (
                                            <p className="not-draggable">
                                                {"This action cannot be reverted, are you sure that you need to permanently delete this item?"}
                                            </p>
                                        ) : (
                                            <p className={`not-draggable ${messageClassName}`}>{message}</p>
                                        )}
                                        {isHard ? (
                                            <p className="not-draggable">
                                                <label className="container-check">
                                                    <input
                                                        className="form-check-input ml-2"
                                                        type="checkbox"
                                                        checked={isDeletePermanent || isDeleted ? "check" : ""}
                                                        disabled={isDeleted}
                                                        onClick={() => this.setState({ isDeletePermanent: !this.state.isDeletePermanent })}
                                                    />{" "}
                                                    Delete permanently<span className="checkmark"></span>
                                                </label>
                                            </p>
                                        ) : null}
                                    </div>
                                    {(this.props.match.params.tab !== "infoimages" && type === "delete" && !this.props.isSurveyAsset) ||
                                    isSurveyImage ? (
                                        <div className="deleteInner">
                                            <p className="not-draggable">Type "DELETE" to confirm</p>
                                            <input
                                                className="form-control not-draggable"
                                                type="text"
                                                onChange={e => this.confirmationDoublecheck(e)}
                                            />
                                        </div>
                                    ) : type === "restore" ? (
                                        <div className="deleteInner">
                                            <p className="not-draggable">Type "RESTORE" to confirm</p>
                                            <input className="form-control not-draggable" type="text" onChange={e => this.confirmRestore(e)} />
                                        </div>
                                    ) : type === "unassign" ? (
                                        <div className="deleteInner">
                                            <p className="not-draggable">Type "YES" to confirm</p>
                                            <input className="form-control not-draggable" type="text" onChange={e => this.confirmUnAssign(e)} />
                                        </div>
                                    ) : type === "sync" ? (
                                        <div className="deleteInner">
                                            <p className="not-draggable">Type "SYNC" to confirm</p>
                                            <input className="form-control not-draggable" type="text" onChange={e => this.confirmSync(e)} />
                                        </div>
                                    ) : type === "remove" ? (
                                        <div className="deleteInner">
                                            <p className="not-draggable">Type "REMOVE" to confirm</p>
                                            <input className="form-control not-draggable" type="text" onChange={e => this.confirmRemove(e)} />
                                        </div>
                                    ) : null}
                                    {this.props?.clientCoreReport > 0 &&
                                        Object.entries(this.getSelectedFilters())?.map(([entityName, filterLabels], index) => (
                                            <div className="category-check-wrap not-draggable">
                                                <h4 style={{ textTransform: "capitalize" }}>Client Core Report</h4>
                                                {Object.entries(filterLabels).map(([key, Values], index) => (
                                                    <div className="d-flex">
                                                        <div className="formInp">
                                                            <div className="col-md-12 checkbox-cover">
                                                                <label className="container-check pl-0">
                                                                    {Values?.label === "FCA Projects" ? "Projects" : Values?.label}
                                                                </label>
                                                            </div>
                                                        </div>
                                                        <div className="formInp">
                                                            <div className="col-md-12 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Keep values
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this?.state?.filterLists?.[entityName]?.[key]?.keep_values}
                                                                            disabled={Values?.label === "FCA Projects"}
                                                                            onClick={e => {
                                                                                this.handleFilterClick(
                                                                                    entityName,
                                                                                    key,
                                                                                    "keep_values",
                                                                                    e.target.checked,
                                                                                    "client"
                                                                                );
                                                                            }}
                                                                        />
                                                                        <span
                                                                            className={`checkmark ${
                                                                                Values?.label === "FCA Projects" ? "cursor-notallowed" : ""
                                                                            }`}
                                                                        ></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="formInp">
                                                            <div className="col-md-12 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Required
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state?.filterLists?.[entityName]?.[key]?.required}
                                                                            disabled={
                                                                                Values?.label === "FCA Projects" ||
                                                                                this.state?.filterLists?.[entityName]?.[key]?.keep_values
                                                                            }
                                                                            onClick={e => {
                                                                                this.handleFilterClick(
                                                                                    entityName,
                                                                                    key,
                                                                                    "required",
                                                                                    e.target.checked,
                                                                                    "client"
                                                                                );
                                                                            }}
                                                                        />
                                                                        <span
                                                                            className={`checkmark ${
                                                                                Values?.label === "FCA Projects" ||
                                                                                this.state?.filterLists?.[entityName]?.[key]?.keep_values
                                                                                    ? "cursor-notallowed"
                                                                                    : ""
                                                                            }`}
                                                                        ></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    {this.props?.globalCoreReport > 0 &&
                                        Object.entries(this.getSelectedFilters())?.map(([entityName, filterLabels], index) => (
                                            <div className="category-check-wrap not-draggable">
                                                <h4 style={{ textTransform: "capitalize" }}>Global Core Report</h4>
                                                {Object.entries(filterLabels).map(([key, Values], index) => (
                                                    <div className="d-flex">
                                                        <div className="formInp">
                                                            <div className="col-md-12 checkbox-cover">
                                                                <label className="container-check pl-0">{Values?.label}</label>
                                                            </div>
                                                        </div>
                                                        <div className="formInp">
                                                            <div className="col-md-12 checkbox-cover">
                                                                <span className="dropdown-item">
                                                                    <label className="container-check">
                                                                        Required
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={this.state?.globalfilterLists?.[entityName]?.[key]?.required}
                                                                            disabled={
                                                                                Values?.label === "FCA Projects" ||
                                                                                this.state?.globalfilterLists?.[entityName]?.[key]?.keep_values
                                                                            }
                                                                            onClick={e => {
                                                                                this.handleFilterClick(
                                                                                    entityName,
                                                                                    key,
                                                                                    "required",
                                                                                    e.target.checked,
                                                                                    "global"
                                                                                );
                                                                            }}
                                                                        />
                                                                        <span
                                                                            className={`checkmark ${
                                                                                Values?.label === "FCA Projects" ||
                                                                                this.state?.globalfilterLists?.[entityName]?.[key]?.keep_values
                                                                                    ? "cursor-notallowed"
                                                                                    : ""
                                                                            }`}
                                                                        ></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    {isRestore ? (
                                        <div className="btnOtr">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btnClr"
                                                onClick={() => onNo()}
                                                ref={input => {
                                                    this.nameInput = input;
                                                }}
                                            >
                                                No
                                            </button>
                                            {this.state.isRestoreCheckOk ? (
                                                <button type="button" className="btn btn-primary btnRgion not-draggable" onClick={() => onYes()}>
                                                    Yes
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btnRgion cursor-diabled not-draggable"
                                                    disabled={true}
                                                >
                                                    Yes
                                                </button>
                                            )}
                                        </div>
                                    ) : isUnAssign || type === "sync" ? (
                                        <div className="btnOtr">
                                            <button
                                                type="button"
                                                className={`btn ${type === "sync" ? "btn-primary btnRgion" : "btn-secondary btnClr"} not-draggable`}
                                                onClick={() => onNo()}
                                                ref={input => {
                                                    this.nameInput = input;
                                                }}
                                            >
                                                No
                                            </button>
                                            {this.state.isUnassignCheckOk || this.state?.isSyncCheckOk ? (
                                                <button
                                                    type="button"
                                                    className={`btn ${
                                                        type === "sync" ? "btn-secondary btnClr" : "btn-primary btnRgion"
                                                    } not-draggable`}
                                                    onClick={() => onYes()}
                                                >
                                                    Yes
                                                </button>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className={`btn ${
                                                        type === "sync" ? "btn-secondary btnClr" : "btn-primary btnRgion"
                                                    } not-draggable`}
                                                    disabled={true}
                                                >
                                                    Yes
                                                </button>
                                            )}
                                        </div>
                                    ) : isCutPaste ? (
                                        <div className="btnOtr">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btnClr not-draggable"
                                                onClick={() => onNo()}
                                                ref={input => {
                                                    this.nameInput = input;
                                                }}
                                            >
                                                No
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary btnRgion not-draggable"
                                                onClick={() => {
                                                    onYes();
                                                }}
                                            >
                                                Yes
                                            </button>
                                        </div>
                                    ) : singleOk ? (
                                        <div className="btnOtr">
                                            <button
                                                type="button"
                                                className="btn btn-primary not-draggable"
                                                onClick={() => onlyOk()}
                                                ref={input => {
                                                    this.nameInput = input;
                                                }}
                                            >
                                                Ok
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="btnOtr">
                                            <button
                                                type="button"
                                                className="btn btn-secondary btnRgion not-draggable mr-2"
                                                onClick={() => onNo()}
                                                ref={input => {
                                                    this.nameInput = input;
                                                }}
                                                disabled={this.props.isLoadingOnYes}
                                                data-tip={clearBtnTooltip || undefined}
                                                data-for="confirmation-modal-btn-tip"
                                                data-multiline={true}
                                            >
                                                {clearBtnLabel || "No"}
                                            </button>
                                            {this.state.isDoubleCheckOk ||
                                            (this.props.match.params.tab === "infoimages" && type !== "remove") ||
                                            (type !== "delete" && type !== "remove" && !isSurveyImage) ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary  btnClr not-draggable"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        isHard
                                                            ? onYes(isDeletePermanent)
                                                            : this.props?.clientCoreReport > 0 || this.props?.globalCoreReport > 0
                                                              ? onYes(this.state.filterLists, this.state.globalfilterLists)
                                                              : onYes();
                                                    }}
                                                    data-tip={confirmBtnTooltip || undefined}
                                                    data-for="confirmation-modal-btn-tip"
                                                    data-multiline={true}
                                                >
                                                    {ConfirmaBtnLabel || "Yes"}
                                                </button>
                                            ) : (
                                                <button type="button" className="btn btn-primary btnClr cursor-diabled not-draggable" disabled={true}>
                                                    {ConfirmaBtnLabel || "Yes"}
                                                </button>
                                            )}
                                            {clearBtnTooltip || confirmBtnTooltip ? (
                                                <ReactTooltip
                                                    id="confirmation-modal-btn-tip"
                                                    effect="solid"
                                                    place="bottom"
                                                    event="mouseenter"
                                                    eventOff="mouseleave"
                                                    multiline={true}
                                                    backgroundColor="#007bff"
                                                    className="rc-tooltip-custom-class confirmation-modal-btn-tip"
                                                />
                                            ) : null}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    const { buildingReducer, recommendationsReducer, dashboardReducer } = state;
    return { buildingReducer, recommendationsReducer, dashboardReducer };
};
export default withRouter(connect(mapStateToProps, { ...recommendationActions, ...buildingActions })(ConfirmationModal));
